module.exports = __webpack_public_path__ + "img/publishing-bg.f1f4aad9.png";